<template>
  <div class="rsvp">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
}
</script>
